import { render, staticRenderFns } from "./ShowMoreButton.vue?vue&type=template&id=00bb989f&scoped=true&"
import script from "./ShowMoreButton.vue?vue&type=script&lang=js&"
export * from "./ShowMoreButton.vue?vue&type=script&lang=js&"
import style0 from "./ShowMoreButton.vue?vue&type=style&index=0&id=00bb989f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bb989f",
  null
  
)

export default component.exports